module.exports = __webpack_public_path__ + "static/img/image@2x (15).f5a9d7b7.png";